import PropTypes from 'prop-types';
import React from 'react';

import TextField from 'app/components/shared/TextField';

import { LISTS_NUM_MAX_LIST_URLS, LISTS_NUM_MIN_LIST_URLS } from 'app/constants/admin/browse/home';
import { listsSectionShape, listsSectionValidationShape } from 'app/shapes/admin/browse/home';
import EditorHasAlternativeBackgroundToggle from './shared/EditorHasAlternativeBackgroundToggle';
import EditorListUrls from './shared/EditorListUrls';

import './SectionEditorLists.scss';

const SectionEditorLists = ({ onChange, section: listsSection, validation }) => {
  const { hasAlternativeBackground, heading, listUrls, sectionId } = listsSection;

  const handleHasAlternativeBackgroundChange = newHasAlternativeBackground => {
    onChange({
      ...listsSection,
      hasAlternativeBackground: newHasAlternativeBackground
    });
  };

  const handleHeadingChange = newHeading => {
    onChange({
      ...listsSection,
      heading: newHeading
    });
  };

  const handleListUrlsChange = newListUrls => {
    onChange({
      ...listsSection,
      listUrls: newListUrls
    });
  };

  const editorHasAlternativeBackgroundToggleKey = `${sectionId}_EditorHasAlternativeBackgroundToggle`;
  const editorListUrlsKey = `${sectionId}_EditorListUrls`;
  const headingInputId = `SectionEditorLists_${sectionId}_Heading`;

  return (
    <div className="cp-admin-browse-home-section-editor-lists">
      <p className="rules">
        {LISTS_NUM_MIN_LIST_URLS}&ndash;{LISTS_NUM_MAX_LIST_URLS} lists can be added.
      </p>

      <div className="heading-field-wrapper">
        <TextField
          errorMessage={validation.errorByAttribute.heading}
          id={headingInputId}
          label="Heading"
          onChange={handleHeadingChange}
          type="text"
          value={heading}
        />
      </div>

      <EditorHasAlternativeBackgroundToggle
        className="toggle-alt-background"
        key={editorHasAlternativeBackgroundToggleKey}
        onChange={handleHasAlternativeBackgroundChange}
        value={hasAlternativeBackground}
      />

      <EditorListUrls
        key={editorListUrlsKey}
        listUrls={listUrls}
        listUrlErrors={validation.errorByAttribute.listUrls}
        numRowsMax={LISTS_NUM_MAX_LIST_URLS}
        numRowsMin={LISTS_NUM_MIN_LIST_URLS}
        onChange={handleListUrlsChange}
      />
    </div>
  );
};

SectionEditorLists.defaultProps = {
  validation: {
    isValid: true,
    errorByAttribute: {
      heading: '',
      listUrls: []
    }
  }
};

SectionEditorLists.propTypes = {
  onChange: PropTypes.func.isRequired,
  section: listsSectionShape.isRequired,
  validation: listsSectionValidationShape
};

export default SectionEditorLists;
